export enum EAccountAuthorityLabel {
  member = 'メンバー',
  admin = '管理者'
}
